<template>
  <b-container class="text-center">
    <h1 class="display-4 fw-bold mb-5" style="text-decoration: underline;">
      {{ $t('comp.start.ui.title.welcome') }}<br>
      <span class="underline">{{ $t('comp.start.ui.title.home') }}</span>
    </h1>
    <img alt="HoMe-Logo" class="mb-1 mt-1" src="../assets/icons/logo/home.png" height="150px">
    <div class="container pt-4 pt-xl-5">
      <div class="card border-dark border-2 d-flex justify-content-center p-3">
        <div class="card-body">
          <div>
            <h3 class="fw-bold">{{ $t('comp.start.ui.info.title') }}</h3>
            <p style="font-size: 25px" class="text-muted d-xl-block">{{ $t('comp.start.ui.info.text') }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!currentUser" class="mt-5">
      <div class="mb-3">
        <b-button @click="login" class="mx-3 mb-3" type="submit" style="background: rgb(0,60,100);">
          <b-icon-box-arrow-in-right/> {{ $t('comp.start.ui.button.login') }}
        </b-button>
        <b-button class="mx-3 mb-3" to="/activate" style="background: rgb(0,60,100);">
          <b-icon-box-arrow-in-right/> {{ $t('comp.start.ui.button.activate') }}
        </b-button>
      </div>
      <div v-if="redirectAfterLogin" class="text-secondary small">
        <b-icon-x-circle @click="clearRedirect" class="cursorPointer" :title="$t('comp.start.remove.redirect.title')"/> {{ redirectAfterLogin }}
      </div>
    </div>
  </b-container>
</template>

<script>
import { authMixin } from '@/mixins/auth.mixin'
import { i18nMixin } from '@rrze/vue-bixins'

export default {
  name: 'StartView',
  i18nCompName: 'start',
  i18n: {
    messages: {}
  },
  mixins: [authMixin, i18nMixin],
  mounted: function () {
    this.docTitle()
  },
  computed: {
    currentLang () {
      return this.$store.state.prefs.lang
    },
    redirectAfterLogin () {
      return this.$store.state.auth.redirectAfterLogin
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    currentLang: function (n, o) {
      this.docTitle()
    },
    // eslint-disable-next-line no-unused-vars
    messagesAvailable: function (n, o) {
      this.docTitle()
    }
  },
  methods: {
    docTitle () {
      document.title = this.$t('comp.start.title')
    },
    clearRedirect () {
      this.$store.commit('auth/clearRedirectAfterLogin')
    },
    login () {
      this.$store.commit('auth/triggerLogin', true)
    }
  }
}
</script>
